"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ryu = void 0;
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const OrOptions_1 = require("../../inputs/OrOptions");
const Resources_1 = require("../../Resources");
const SelectOption_1 = require("../../inputs/SelectOption");
const SelectAmount_1 = require("../../inputs/SelectAmount");
class Ryu extends Card_1.Card {
    constructor() {
        super({
            name: CardName_1.CardName.RYU,
            cardType: CardType_1.CardType.LEADER,
            metadata: {
                cardNumber: 'L30',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.opgArrow().text('ACTIVATE THE BELOW ABILITY');
                    b.br;
                    b.text('SWAP X+2').production((pb) => pb.wild(1));
                    b.br.br;
                }),
                description: 'Once per game, swap up to X+2 of ANY two productions, where X is the current generation number.',
            },
        });
        this.isDisabled = false;
    }
    play() {
        return undefined;
    }
    canAct(player) {
        const resources = [Resources_1.Resources.MEGACREDITS, Resources_1.Resources.STEEL, Resources_1.Resources.TITANIUM, Resources_1.Resources.PLANTS, Resources_1.Resources.ENERGY, Resources_1.Resources.HEAT];
        if (resources.some((res) => this.productionIsDecreasable(player, res)) === false)
            return false;
        return this.isDisabled === false;
    }
    action(player) {
        const resources = [Resources_1.Resources.MEGACREDITS, Resources_1.Resources.STEEL, Resources_1.Resources.TITANIUM, Resources_1.Resources.PLANTS, Resources_1.Resources.ENERGY, Resources_1.Resources.HEAT];
        const choices = new OrOptions_1.OrOptions();
        resources.filter((r) => this.productionIsDecreasable(player, r)).forEach((resourceToDecrease) => {
            const selectOption = new SelectOption_1.SelectOption(`Decrease ${resourceToDecrease} production`, 'Select', () => {
                const decreasable = resourceToDecrease === Resources_1.Resources.MEGACREDITS ? player.getProduction(resourceToDecrease) + 5 : player.getProduction(resourceToDecrease);
                const maxDecreasableAmt = Math.min(player.game.generation + 2, decreasable);
                return new SelectAmount_1.SelectAmount(`Select amount of ${resourceToDecrease} production to decrease`, 'Decrease', (amount) => {
                    const productionToIncrease = resources.filter((res) => res !== resourceToDecrease)
                        .map((res) => new SelectOption_1.SelectOption(`Increase ${res} production`, 'Select', () => {
                        player.addProduction(resourceToDecrease, -amount, { log: true });
                        player.addProduction(res, amount, { log: true });
                        return undefined;
                    }));
                    return new OrOptions_1.OrOptions(...productionToIncrease);
                }, 1, maxDecreasableAmt, true);
            });
            choices.options.push(selectOption);
        });
        this.isDisabled = true;
        return choices;
    }
    productionIsDecreasable(player, resource) {
        if (resource === Resources_1.Resources.MEGACREDITS)
            return player.getProduction(resource) > -5;
        return player.getProduction(resource) > 0;
    }
}
exports.Ryu = Ryu;
//# sourceMappingURL=Ryu.js.map